import { graphql, useStaticQuery } from 'gatsby';

const useComparisonCompayCards = () => {
  const { allContentfulImage } = useStaticQuery(graphql`
    query {
      allContentfulImage(
        filter: {
          contentful_id: {
            in: [
              "4cFD9L8In7BegDVOF5RCkJ" #Field Edge Logo
              "MIHnUcBrTtNPQrzd5uK09" #jobber
              "3JcScpHuKDAyiONWnNQinZ" #Kicksev
              "14LtrYd1YggyYapI3Gn3Nh" #Servman
              "ZsU3RmpgvzjrevAlwqOkq" #Smart Service
              "5eDcMiIuiWcRuwlBX2itHq" #Successware 21
              "3KSQIFuxTh4xPbB4Yxv2bE" #hcp-logo
              "26RipHaMNfPnfkXnQXXv9b" #housecall-vs-jobbers
              "6LtBXI7BWZQ3Kvy7SwupkN" #successware
            ]
          }
        }
      ) {
        edges {
          node {
            contentful_id
            internalName
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
  `);
  const findImage = internalName =>
    allContentfulImage.edges.find(i => i.node.internalName === internalName)?.node?.image?.file.url;

  const cardInfo = [
    {
      title: 'ServiceTitan vs FieldEdge',
      link: '/comparison/servicetitan-vs-fieldedge',
      logo: findImage('Field Edge Logo'),
    },
    {
      title: 'ServiceTitan vs Jobber',
      link: '/comparison/servicetitan-vs-jobber',
      logo: findImage('jobber'),
    },
    {
      title: 'ServiceTitan vs Kickserv',
      link: '/comparison/servicetitan-vs-kickserv',
      logo: findImage('Kicksev'),
    },
    {
      title: 'ServiceTitan vs Smart Service',
      link: '/comparison/servicetitan-vs-smart-service',
      logo: findImage('Smart Service'),
    },
    {
      title: 'ServiceTitan vs Housecall Pro',
      link: '/comparison/servicetitan-vs-housecall-pro',
      logo: findImage('hcp-logo'),
    },
    {
      title: 'ServiceTitan vs Successware',
      link: '/comparison/servicetitan-vs-successware',
      logo: findImage('successware'),
    },
    {
      title: 'ServiceTitan vs Housecall Pro & Jobber',
      link: '/comparison/housecall-pro-vs-jobber',
      logo: findImage('housecall-vs-jobbers'),
    },
    {
      title: 'ServiceTitan vs Service Fusion',
      link: '/comparison/servicetitan-vs-service-fusion',
      company: 'Service Fusion',
    },
  ];
  return cardInfo;
};

export default useComparisonCompayCards;
